import { router, Stack } from 'expo-router';
import React from 'react';

import { PlusSignIcon } from '@hugeicons/core-free-icons';
import HeaderButton from '@molecules/HeaderButton';
import HeaderDrawerButton from '@molecules/HeaderDrawerButton';

import { headerOptionsCreator } from '@utils/screenOptions';

export default function Layout() {
  return (
    <Stack>
      <Stack.Screen
        name="index"
        options={headerOptionsCreator(
          HeaderDrawerButton,
          <HeaderButton
            icon={PlusSignIcon}
            onPress={() => {
              router.navigate('/newMessage');
            }}
          />,
        )}
      />
      <Stack.Screen
        name="[conversationId]"
        options={headerOptionsCreator(
          <HeaderButton onPress={() => router.navigate('/inbox/all')} />,
        )}
      />
    </Stack>
  );
}
